export enum AccordionTypes {
  PROFESSOR_COMMENTS = 'PROFESSOR_COMMENTS',
}
